<template>
    <v-dialog v-model="internalDialog" persistent class="mx-auto" fullscreen scrollable
        style="z-index: 30000 !important;">
        <v-card class="glassmorphism-card" style="border-radius: 0px 0px 0 0;">
            <div class="pa-8">
                <div class="icon-container">
                    <v-img src="../../assets/dialogwarning.svg"></v-img>
                </div>

                <div class="d-flex flex-column ga-3 mb-6">
                    <v-btn @click="handleSignIn('google')" class="premium-btn-primary" size="large" rounded="xl"
                        :loading="loadingGoogle" :disabled="loadingGoogle">
                        <v-icon start>mdi-google</v-icon>
                        {{ loadingGoogle ? $t('signin.connecting') : $t('signin.continueGoogle') }}
                    </v-btn>

                    <v-btn @click="handleSignIn('email')" class="premium-btn-secondary" size="large" rounded="xl"
                        variant="outlined">
                        <v-icon start>mdi-email</v-icon>
                        {{ $t('signin.emailPassword') }}
                    </v-btn>
                </div>

                <div class="d-flex align-start ga-3">
                    <v-checkbox v-model="check" color="#C2185B" hide-details></v-checkbox>
                    <div class="glass-terms">
                        <i18n-t keypath="signin.acceptTerms" tag="span">
                            <template #privacy>
                                <span @click="navigateTo('/PolitiqueUserPage')" class="terms-link">
                                    {{ $t('home.privacyPolicy') }}
                                </span>
                            </template>
                            <template #conditions>
                                <span @click="navigateTo('/ConditionUserPage')" class="terms-link">
                                    {{ $t('home.termsOfUse') }}
                                </span>
                            </template>
                        </i18n-t>
                    </div>
                </div>

                <span v-if="showError" class="text-danger mt-2 text-wrap text-center">
                    {{ $t('signin.checkboxError') }}
                </span>
            </div>

            <v-btn class="mx-auto text-none" rounded="pill" variant="tonal" @click="goTo()">
                {{ $t('signin.close') }}
            </v-btn>
        </v-card>
    </v-dialog>

    <v-dialog v-model="signWithEmail" persistent fullscreen scrollable style="z-index: 30000 !important;">
        <v-card class="glassmorphism-dialog" style="padding-top: env(safe-area-inset-top, 44px);">
            <div class="d-flex justify-start pa-4 pb-0">
                <v-btn @click="closeDialog" class="glassmorphism-close-btn" icon size="40">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-text class="glassmorphism-content">

                <!-- Login Form -->
                <v-form v-if="isLogin" @submit.prevent="login" class="glassmorphism-form">
                    <h2 class="glassmorphism-title">{{ $t('signin.loginTitle') }}</h2>

                    <div class="glassmorphism-fields">
                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.emailLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="email" type="email" :placeholder="$t('signin.emailLabel')"
                                    class="glassmorphism-input" autocomplete="email" required />
                                <span v-if="email" @click="email = ''" class="glassmorphism-clear-btn">×</span>
                                <div class="glassmorphism-input-icon">
                                    <v-icon color="rgba(255, 255, 255, 0.7)">mdi-email</v-icon>
                                </div>
                            </div>
                        </div>

                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.passwordLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="password" :type="visible ? 'text' : 'password'"
                                    :placeholder="$t('signin.passwordLabel')" class="glassmorphism-input"
                                    autocomplete="current-password" required />
                                <span v-if="password" @click="password = ''" class="glassmorphism-clear-btn">×</span>
                                <button type="button" @click="visible = !visible" class="glassmorphism-visibility-btn">
                                    <v-icon :color="visible ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.5)'">
                                        {{ visible ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </button>
                            </div>
                        </div>

                        <p v-if="errMsg" class="glassmorphism-error">{{ errMsg }}</p>

                        <v-btn @click="login" class="glassmorphism-btn-primary" size="large" block rounded="xl"
                            :loading="loading2">
                            {{ $t('signin.loginBtn') }}
                        </v-btn>

                        <p @click="navigateTo('/ForgotPasswordPage')" class="glassmorphism-link">
                            {{ $t('signin.forgotPassword') }}
                        </p>

                        <v-btn @click="navigateTo('/ForgotPasswordPage')" class="glassmorphism-btn-secondary"
                            size="large" block rounded="xl">
                            {{ $t('signin.newPassword') }}
                        </v-btn>

                        <p @click="switchToRegister" class="glassmorphism-link">
                            {{ $t('signin.notRegistered') }}
                        </p>

                        <v-btn @click="switchToRegister" class="glassmorphism-btn-tertiary" size="large" block
                            rounded="xl">
                            {{ $t('signin.registerBtn') }}
                        </v-btn>
                    </div>
                </v-form>

                <!-- Register Form -->
                <v-form v-if="!isLogin" @submit.prevent="register" class="glassmorphism-form">
                    <h2 class="glassmorphism-title">{{ $t('signin.registerTitle') }}</h2>

                    <div class="glassmorphism-fields">
                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.lastNameLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="siyati" type="text" :placeholder="$t('signin.lastNameLabel')"
                                    class="glassmorphism-input" autocomplete="text" required />
                                <span v-if="siyati" @click="siyati = ''" class="glassmorphism-clear-btn">×</span>
                                <div class="glassmorphism-input-icon">
                                    <v-icon color="rgba(255, 255, 255, 0.7)">mdi-account</v-icon>
                                </div>
                            </div>
                        </div>

                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.firstNameLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="non" type="text" :placeholder="$t('signin.firstNameLabel')"
                                    class="glassmorphism-input" autocomplete="text" required />
                                <span v-if="non" @click="non = ''" class="glassmorphism-clear-btn">×</span>
                                <div class="glassmorphism-input-icon">
                                    <v-icon color="rgba(255, 255, 255, 0.7)">mdi-account</v-icon>
                                </div>
                            </div>
                        </div>

                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.emailLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="email" type="email" :placeholder="$t('signin.emailLabel')"
                                    class="glassmorphism-input" autocomplete="email" required />
                                <span v-if="email" @click="email = ''" class="glassmorphism-clear-btn">×</span>
                                <div class="glassmorphism-input-icon">
                                    <v-icon color="rgba(255, 255, 255, 0.7)">mdi-email</v-icon>
                                </div>
                            </div>
                        </div>

                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.passwordLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="password" :type="visible ? 'text' : 'password'"
                                    :placeholder="$t('signin.passwordLabel')" class="glassmorphism-input"
                                    autocomplete="current-password" required />
                                <span v-if="password" @click="password = ''" class="glassmorphism-clear-btn">×</span>
                                <button type="button" @click="visible = !visible" class="glassmorphism-visibility-btn">
                                    <v-icon :color="visible ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.5)'">
                                        {{ visible ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </button>
                            </div>
                        </div>

                        <div class="glassmorphism-field-group">
                            <label class="glassmorphism-label">{{ $t('signin.confirmPasswordLabel') }}</label>
                            <div class="glassmorphism-input-container">
                                <input v-model="confirmPassword" :type="visible ? 'text' : 'password'"
                                    :placeholder="$t('signin.confirmPasswordLabel')" class="glassmorphism-input"
                                    autocomplete="current-password" required />
                                <span v-if="confirmPassword" @click="confirmPassword = ''"
                                    class="glassmorphism-clear-btn">×</span>
                                <button type="button" @click="visible = !visible" class="glassmorphism-visibility-btn">
                                    <v-icon :color="visible ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.5)'">
                                        {{ visible ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </button>
                            </div>
                        </div>

                        <p v-if="registrationMessage" class="glassmorphism-error">{{ registrationMessage }}</p>

                        <v-btn @click="register" class="glassmorphism-btn-primary" size="large" block rounded="xl"
                            :loading="loading3">
                            {{ $t('signin.registerBtn') }}
                        </v-btn>

                        <p class="glassmorphism-link-text">{{ $t('signin.alreadyRegistered') }}</p>

                        <v-btn @click="switchToLogin" class="glassmorphism-btn-secondary" size="large" block
                            rounded="xl">
                            {{ $t('signin.loginBtn') }}
                        </v-btn>
                    </div>
                </v-form>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from "vue";
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { Device } from '@capacitor/device';
import {
    getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword,
    GoogleAuthProvider, signInWithPopup, signInWithCredential,
    linkWithCredential, EmailAuthProvider, linkWithPopup,
} from "firebase/auth";
import { useRouter } from 'vue-router';
import { defineProps, defineEmits } from 'vue';
import { db } from "@/main";
import { collection, setDoc, doc, serverTimestamp, getDoc, updateDoc, where, getDocs, query } from 'firebase/firestore';

const props = defineProps({
    dialog: { type: Boolean, required: true },
    dialog2: { type: Boolean, required: false, default: false }
});

const emit = defineEmits(['update:dialog', 'update:dialog2']);

// 🔥 Accès à $t dans script setup
const { proxy } = getCurrentInstance();
const t = (key) => proxy.$t(key);

// ===== Variables d'état =====
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const siyati = ref("");
const non = ref("");
const errMsg = ref("");
const registrationMessage = ref("");
const visible = ref(false);
const internalDialog = ref(props.dialog);
const signWithEmail = ref(props.dialog2);
const isLogin = ref(true);
const router = useRouter();
const check = ref(false);
const showError = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
const loadingGoogle = ref(false);

// ===== Règles =====
const rules = {
    required: value => !!value || t('signin.errorRequired'),
    min: (v) => v.length >= 8 || t('signin.errorMinPassword'),
};

// ===== Watchers =====
watch(() => props.dialog, (val) => { internalDialog.value = val; });
watch(internalDialog, (val) => { emit('update:dialog', val); });
watch(() => props.dialog2, (val) => { signWithEmail.value = val; });
watch(signWithEmail, (val) => { emit('update:dialog2', val); });

// ===== Méthodes =====
const handleSignIn = (method) => {
    if (!check.value) { showError.value = true; return; }
    showError.value = false;
    if (method === "google") {
        signInWithGoogle();
    } else if (method === "email") {
        internalDialog.value = false;
        setTimeout(() => { signWithEmail.value = true; }, 300);
    }
};

const closeDialog = () => {
    email.value = ''; password.value = ''; siyati.value = '';
    non.value = ''; confirmPassword.value = '';
    signWithEmail.value = false;
    internalDialog.value = false;
    if (window.AndroidFullScreen?.showSystemUI) window.AndroidFullScreen.showSystemUI();
    StatusBar.setOverlaysWebView({ overlay: true });
};

const goTo = () => {
    internalDialog.value = false;
    if (window.AndroidFullScreen?.showSystemUI) window.AndroidFullScreen.showSystemUI();
    StatusBar.setOverlaysWebView({ overlay: true });
};

const switchToLogin = () => { isLogin.value = true; };
const switchToRegister = () => { isLogin.value = false; };

// ===== Device ID =====
const getDeviceId = async () => {
    try {
        if (Capacitor.isNativePlatform()) {
            const info = await Device.getId();
            return info.identifier;
        } else {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            ctx.textBaseline = 'top';
            ctx.font = '14px Arial';
            ctx.fillText('Device fingerprint', 2, 2);
            const fingerprint = canvas.toDataURL() + navigator.userAgent + navigator.language +
                screen.width + 'x' + screen.height + new Date().getTimezoneOffset();
            let hash = 0;
            for (let i = 0; i < fingerprint.length; i++) {
                const char = fingerprint.charCodeAt(i);
                hash = ((hash << 5) - hash) + char;
                hash = hash & hash;
            }
            return Math.abs(hash).toString();
        }
    } catch (error) {
        return 'unknown-device-' + Date.now();
    }
};

// ===== Firestore =====
const getNonFromEmail = (email) => {
    const prefix = email.split("@")[0];
    const parts = prefix.split(".");
    if (parts.length > 1) {
        return { firstName: parts[0], lastName: parts[1] };
    } else {
        return {
            firstName: prefix,
            lastName: `${Math.floor(Math.random() * 10)}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 10)}`,
        };
    }
};

const saveUserToFirestore = async (user, deviceId) => {
    const userDocRef = doc(collection(db, "users"), user.uid);
    const userDoc = await getDoc(userDocRef);
    if (!userDoc.exists()) {
        const { firstName, lastName } = getNonFromEmail(user.email);
        await setDoc(userDocRef, {
            userId: user.uid, imel: user.email,
            created: serverTimestamp(), dateInscription: serverTimestamp(),
            lastLogin: serverTimestamp(), non: firstName, siyati: lastName,
            photoURL: user.photoURL || '', deviceId, admin: false, premium: false,
        });
    } else {
        await updateDoc(userDocRef, { lastLogin: serverTimestamp(), isOnline: true, deviceId });
    }
};

// ===== Login =====
const login = async () => {
    loading2.value = true;
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const wasAnonymous = currentUser?.isAnonymous;

    try {
        const deviceId = await getDeviceId();
        let anonGift = 0, anonCreditsBought = 0, anonPremium = false;

        if (wasAnonymous) {
            const anonDoc = await getDoc(doc(db, 'users', currentUser.uid));
            if (anonDoc.exists()) {
                anonGift = anonDoc.data().gift || 0;
                anonCreditsBought = anonDoc.data().creditsBought || 0;
                anonPremium = anonDoc.data().premium || false;
            }
        }

        const result = await signInWithEmailAndPassword(auth, email.value, password.value);
        const user = result.user;
        const userRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
            if (wasAnonymous && anonGift + anonCreditsBought > 0) {
                const realGift = userDoc.data().gift || 0;
                const realCreditsBought = userDoc.data().creditsBought || 0;
                const realPremium = userDoc.data().premium || false;
                await updateDoc(userRef, {
                    gift: realGift + anonGift, creditsBought: realCreditsBought + anonCreditsBought,
                    premium: realPremium || anonPremium, lastLogin: serverTimestamp(), isOnline: true, deviceId,
                });

                // 🔥 AJOUTER : remettre à 0 l'ancien compte anonyme
                await updateDoc(doc(db, 'users', currentUser.uid), {
                    gift: 0,
                    creditsBought: 0,
                });
            } else {
                await updateDoc(userRef, { lastLogin: serverTimestamp(), isOnline: true, deviceId });
            }
        }

        email.value = ''; password.value = '';
        signWithEmail.value = false; internalDialog.value = false;
        loading2.value = false;
        if (window.AndroidFullScreen?.showSystemUI) window.AndroidFullScreen.showSystemUI();
        localStorage.setItem('alreadyConnected', 'true');
        StatusBar.setOverlaysWebView({ overlay: true });
        router.push('/HomePage');

    } catch (error) {
        loading2.value = false;
        // 🔥 Messages traduits
        switch (error.code) {
            case "auth/invalid-email": errMsg.value = t('signin.errorInvalidEmail'); break;
            case "auth/user-not-found": errMsg.value = t('signin.errorUserNotFound'); break;
            case "auth/wrong-password": errMsg.value = t('signin.errorWrongPassword'); break;
            default: errMsg.value = t('signin.errorDefault'); break;
        }
    }
};

// ===== Register =====
const register = async () => {
    loading3.value = true;

    if (!rules.required(password.value)) { registrationMessage.value = rules.required(password.value); loading3.value = false; return; }
    if (!rules.min(password.value)) { registrationMessage.value = rules.min(password.value); loading3.value = false; return; }
    if (password.value !== confirmPassword.value) {
        registrationMessage.value = t('signin.errorPasswordMismatch');
        loading3.value = false; return;
    }

    try {
        const auth = getAuth();
        const currentUser = auth.currentUser;
        const wasAnonymous = currentUser?.isAnonymous;
        const deviceId = await getDeviceId();
        let user;

        if (wasAnonymous) {
            try {
                const credential = EmailAuthProvider.credential(email.value, password.value);
                const result = await linkWithCredential(currentUser, credential);
                user = result.user;
                await updateDoc(doc(db, 'users', user.uid), {
                    imel: email.value, non: non.value, siyati: siyati.value,
                    dateInscription: serverTimestamp(), lastLogin: serverTimestamp(),
                    isOnline: true, deviceId,
                });
            } catch (linkError) {
                registrationMessage.value = linkError.code === 'auth/email-already-in-use'
                    ? t('signin.errorEmailExists')
                    : t('signin.errorRegistration');
                loading3.value = false; return;
            }
        } else {
            const emailSnapshot = await getDocs(query(collection(db, 'users'), where("imel", "==", email.value)));
            if (!emailSnapshot.empty) {
                registrationMessage.value = t('signin.errorEmailExistsRegister');
                loading3.value = false; return;
            }
            const userCredential = await createUserWithEmailAndPassword(auth, email.value, password.value);
            user = userCredential.user;
            await setDoc(doc(db, 'users', user.uid), {
                userId: user.uid, imel: email.value,
                created: serverTimestamp(), dateInscription: serverTimestamp(),
                lastLogin: serverTimestamp(), non: non.value, siyati: siyati.value,
                photoURL: '', deviceId, premium: false,
            });
        }

        registrationMessage.value = '';
        signWithEmail.value = false; internalDialog.value = false;
        loading3.value = false;
        if (window.AndroidFullScreen?.showSystemUI) window.AndroidFullScreen.showSystemUI();
        localStorage.setItem('alreadyConnected', 'true');
        StatusBar.setOverlaysWebView({ overlay: true });
        router.push('/HomePage');

    } catch (error) {
        loading3.value = false;
        switch (error.code) {
            case "auth/invalid-email": registrationMessage.value = t('signin.errorInvalidEmail'); break;
            case "auth/email-already-in-use": registrationMessage.value = t('signin.errorEmailExists'); break;
            case "auth/weak-password": registrationMessage.value = t('signin.errorWeakPassword'); break;
            default: registrationMessage.value = t('signin.errorRegistration'); break;
        }
    }
};

// ===== Google Sign In =====
const signInWithGoogle = async () => {
    loadingGoogle.value = true;
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const wasAnonymous = currentUser?.isAnonymous;
    const anonUid = currentUser?.uid;

    try {
        const deviceId = await getDeviceId();
        let user;
        let anonGift = 0, anonCreditsBought = 0, anonPremium = false;

        if (wasAnonymous) {
            const anonDoc = await getDoc(doc(db, 'users', currentUser.uid));
            if (anonDoc.exists()) {
                anonGift = anonDoc.data().gift || 0;
                anonCreditsBought = anonDoc.data().creditsBought || 0;
                anonPremium = anonDoc.data().premium || false;
            }
        }

        if (Capacitor.isNativePlatform()) {
            const googleUser = await GoogleAuth.signIn();
            const idToken = googleUser.authentication.idToken;
            const credential = GoogleAuthProvider.credential(idToken);

            if (wasAnonymous) {
                const tempResult = await signInWithCredential(auth, credential);
                const userDocRef = doc(db, 'users', tempResult.user.uid);
                const userDoc = await getDoc(userDocRef);

                if (!userDoc.exists()) {
                    try {
                        const result = await linkWithCredential(currentUser, credential);
                        user = result.user;
                        await updateDoc(doc(db, 'users', user.uid), {
                            imel: user.email || '', photoURL: user.photoURL || '',
                            lastLogin: serverTimestamp(), isOnline: true, deviceId,
                        });
                    } catch {
                        const result = await signInWithCredential(auth, credential);
                        user = result.user;
                        await saveUserToFirestore(user, deviceId);
                    }
                } else {
                    user = tempResult.user;
                    const realGift = userDoc.data().gift || 0;
                    const realCreditsBought = userDoc.data().creditsBought || 0;
                    const realPremium = userDoc.data().premium || false;
                    await updateDoc(userDocRef, {
                        gift: realGift + anonGift, creditsBought: realCreditsBought + anonCreditsBought,
                        premium: realPremium || anonPremium, lastLogin: serverTimestamp(), isOnline: true, deviceId,
                    });

                    // 🔥 Vider l'ancien compte anonyme
                    await updateDoc(doc(db, 'users', anonUid), {
                        gift: 0,
                        creditsBought: 0,
                    });
                }
            } else {
                const result = await signInWithCredential(auth, credential);
                user = result.user;
                const userDocRef = doc(db, 'users', user.uid);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    await updateDoc(userDocRef, { lastLogin: serverTimestamp(), isOnline: true, deviceId });

                } else {
                    await saveUserToFirestore(user, deviceId);
                }
            }
        } else {
            const provider = new GoogleAuthProvider();
            if (wasAnonymous) {
                try {
                    const result = await linkWithPopup(currentUser, provider);
                    user = result.user;
                    await updateDoc(doc(db, 'users', user.uid), {
                        imel: user.email || '', photoURL: user.photoURL || '',
                        lastLogin: serverTimestamp(), isOnline: true, deviceId,
                    });
                } catch {
                    const result = await signInWithPopup(auth, provider);
                    user = result.user;
                    const userDocRef = doc(db, 'users', user.uid);
                    const userDoc = await getDoc(userDocRef);
                    if (userDoc.exists()) {
                        const realGift = userDoc.data().gift || 0;
                        const realCreditsBought = userDoc.data().creditsBought || 0;
                        const realPremium = userDoc.data().premium || false;
                        await updateDoc(userDocRef, {
                            gift: realGift + anonGift, creditsBought: realCreditsBought + anonCreditsBought,
                            premium: realPremium || anonPremium, lastLogin: serverTimestamp(), isOnline: true, deviceId,
                        });

                        await updateDoc(doc(db, 'users', currentUser.uid), {
                            gift: 0,
                            creditsBought: 0,
                        });
                    }
                }
            } else {
                const result = await signInWithPopup(auth, provider);
                user = result.user;
                const userDocRef = doc(db, 'users', user.uid);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    await updateDoc(userDocRef, { lastLogin: serverTimestamp(), isOnline: true, deviceId });
                } else {
                    await saveUserToFirestore(user, deviceId);
                }
            }
        }

        internalDialog.value = false; signWithEmail.value = false;
        loadingGoogle.value = false;
        if (window.AndroidFullScreen?.showSystemUI) window.AndroidFullScreen.showSystemUI();
        localStorage.setItem('alreadyConnected', 'true');
        StatusBar.setOverlaysWebView({ overlay: true });
        router.push('/HomePage');

    } catch (error) {
        loadingGoogle.value = false;
        // 🔥 Message traduit
        registrationMessage.value = t('signin.errorGoogle');
    }
};

const navigateTo = (route) => {
    signWithEmail.value = false;
    internalDialog.value = false;
    router.push(route);
};
</script>

<style scoped>
.text-amber-darken-4 {
    margin-bottom: 20px;
    margin-left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    text-decoration: none;
}

.text-grey {
    color: grey;
}

.btn-amber-darken-4 {
    background-color: yellow;
    color: black;
}

.btn-grey {
    background-color: grey;
    color: white;
}





.glassmorphism-card {
    /* backdrop-filter: blur(20px); */
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.handle-bar {
    width: 40px;
    height: 4px;
    border-radius: 2px;
    margin: 0 auto 24px;
}

.icon-container {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.glass-title {
    color: #1a1a1a;
    font-size: 24px;
    font-weight: 800;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 8px;
}

.glass-subtitle {
    color: #4a5568;
    font-size: 16px;
    font-weight: 500;
}

.premium-btn-primary {
    background: #C2185B;
    box-shadow: 0 8px 24px rgba(255, 111, 0, 0.3);
    color: white !important;
    text-transform: none;
    font-weight: 700;
}

.premium-btn-secondary {
    background: white;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(10px);
    color: #1a1a1a !important;
    text-transform: none;
    font-weight: 600;
}

.glass-terms {
    font-size: 14px;
    color: #4a5568;
    line-height: 1.5;
}

.terms-link {
    color: #C2185B;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
}




.glassmorphism-dialog {
    backdrop-filter: blur(20px);
    width: 100% !important;
    height: 100vh !important;
    border-radius: 0 !important;
}

.glassmorphism-close-btn {
    background: rgba(255, 255, 255, 0.2) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
}

.glassmorphism-close-btn:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    transform: scale(1.05);
}

.glassmorphism-content {
    height: 100vh;
    overflow-y: auto;
}

.glassmorphism-form {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 16px;
    width: 100%;
    max-width: 400px;
}

.glassmorphism-title {
    color: white;
    font-size: 28px;
    font-weight: 800;
    text-align: center;
    margin: 0 0 32px 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.glassmorphism-fields {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 50px;
}

.glassmorphism-field-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.glassmorphism-label {
    color: rgba(255, 255, 255, 0.9);
    font-size: 16px;
    font-weight: 600;
}

.glassmorphism-input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.glassmorphism-input {
    width: 100%;
    padding: 16px 50px 16px 16px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    color: white;
    font-size: 16px;
    font-weight: 500;
    backdrop-filter: blur(10px);
    outline: none;
    transition: all 0.3s ease;
}

.glassmorphism-input:focus {
    border: 1px solid rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
}

.glassmorphism-input::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.glassmorphism-clear-btn {
    position: absolute;
    right: 50px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    font-size: 18px;
    z-index: 1;
    transition: color 0.3s ease;
}

.glassmorphism-clear-btn:hover {
    color: white;
}

.glassmorphism-input-icon {
    position: absolute;
    right: 16px;
    pointer-events: none;
}

.glassmorphism-visibility-btn {
    position: absolute;
    right: 16px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 1;
    transition: all 0.3s ease;
}

.glassmorphism-visibility-btn:hover {
    transform: scale(1.1);
}

.glassmorphism-error {
    color: #ffcdd2;
    text-align: center;
    font-size: 14px;
    margin: 0;
    padding: 12px;
    background: rgba(244, 67, 54, 0.2);
    border: 1px solid rgba(244, 67, 54, 0.3);
    border-radius: 12px;
    backdrop-filter: blur(10px);
}

.glassmorphism-btn-primary {
    background: #C2185B !important;
    color: white !important;
    box-shadow: 0 8px 24px rgba(255, 111, 0, 0.3);
    text-transform: none;
    font-weight: 700;
    font-size: 16px;
    border: none !important;
}

.glassmorphism-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(255, 111, 0, 0.4);
}

.glassmorphism-btn-secondary {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    text-transform: none;
    font-weight: 600;
    font-size: 16px;
}

.glassmorphism-btn-secondary:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    transform: translateY(-1px);
}

.glassmorphism-btn-tertiary {
    background: white !important;
    color: black !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    text-transform: none;
    font-weight: 600;
    font-size: 16px;
}

.glassmorphism-btn-tertiary:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

.glassmorphism-link {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    margin: 0;
    transition: color 0.3s ease;
}

.glassmorphism-link:hover {
    color: white;
}

.glassmorphism-link-text {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    text-align: center;
    margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
    .glassmorphism-form {
        padding: 12px;
    }

    .glassmorphism-title {
        font-size: 24px;
    }

    .glassmorphism-input {
        padding: 14px 45px 14px 14px;
        font-size: 15px;
    }
}

.favicon {
    width: 80px;
    height: 80px;
}
</style>
